import { LoggedError } from "./LoggedError";

export class ServiceError extends LoggedError {
  constructor(error) {
    super(error, LoggedError.warn);
    this.name = "ServiceError";
  }
}
